<div class="app-shell">
  <main [class.admin]="isAdmin">
    <img src="/assets/pthyxs_game_banner.png" alt="Key Visual Banner" class="kv-banner" />
    <router-outlet class="content-box"></router-outlet>
  </main>
  <footer>
    <div class="footer-content">
      <p>版權所有 © {{ currentYear }} 香港語言研究中心</p>
    </div>
  </footer>
</div>
